export default "__VITE_ASSET__DBEzoAR0__"